<template>
  <div class="loader text-center"></div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'loader'
}
</script>
